import { render, staticRenderFns } from "./InvoiceCreated.vue?vue&type=template&id=7b2564aa&scoped=true"
import script from "./InvoiceCreated.vue?vue&type=script&lang=js"
export * from "./InvoiceCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2564aa",
  null
  
)

export default component.exports